import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Spin } from 'antd';
import axiosClient from './api/axiosClient';
import { tokenService } from './services/tokenService';
import MemberLogin from "./pages/auth/MemberLogin.js";
import MemberDashboard from "./pages/dash/MemberDashboard.js";
import MemberMetrics from "./pages/dash/MemberMetrics.js";
import MemberInvoices from "./pages/dash/MemberInvoices.js";
import MemberTrainers from "./pages/dash/MemberTrainers.js";
import MemberLayout from "./pages/layout/MemberLayout.js";
import ChangePassword from "./pages/auth/ChangePassword.js";
import ResetPassword from "./pages/auth/ResetPassword.js";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = tokenService.getAccessToken();
      if (!token) {
        try {
          const response = await axiosClient.post('/portal/refresh.php');
          if (response.status === 200 && response.data.access_token) {
            tokenService.setAccessToken(response.data.access_token);
          }
        } catch (error) {
          console.log("Silent refresh failed", error);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/dash" replace />} />
        <Route path="/login" element={<MemberLogin />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Private Member Routes */}
        <Route element={<MemberLayout />}>
          <Route path="/dash" element={<MemberDashboard />} />
          <Route path="/metrics" element={<MemberMetrics />} />
          <Route path="/invoices" element={<MemberInvoices />} />
          <Route path="/trainers" element={<MemberTrainers />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dash" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;